import { useState, useEffect } from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import Generalsidebar from "../Generalsidebar";
import RelaxationSidebar from "../relaxation/RelaxationSidebar";
import { Link } from "react-router-dom";

const moodURL = "https://thrive-mqy3.onrender.com/v1/moods";
const accessToken = localStorage.getItem("accessToken");
console.log("accesstoken", accessToken);
function MoodUi() {
  const [allMoods, setAllMoods] = useState(null);
  useEffect(() => {
    const userDetail = {
      method: "GET",

      headers: { Authorization: `Bearer ${accessToken}` },
    };
    fetch(moodURL, userDetail)
      .then((response) => response.json())

      .then((data) => {
        console.log("all moods", data);
        setAllMoods(data.reverse());
        // localStorage.setItem("currentMood", JSON.stringify(data));
      });
  }, [moodURL]);
  // getMoods()
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const moodSmiley = {
    happy: "😄",
    excited: "🤩",
    veryHappy: "😃",
    chill: "😎",
    neutral: "😐",
    sad: "😭",
    anxious: "😖",
    angry: "😡",
  };

  function convertKeyToCamelCase(key) {
    const keyArray = key.replaceAll(" ", "").split("");
    const keyStart = `${keyArray[0]}`.toLowerCase();
    keyArray.shift();
    keyArray.unshift(keyStart);
    return keyArray.join("");
  }
  
  console.log(convertKeyToCamelCase("We Good Today Man"));

  return (
    <div className="bg-[#D9D9D9]">
      <Navbar />
      <div className="flex gap-4 ">
        <RelaxationSidebar />
        <Link to="/moodtrack">
          <button className="flex mt-8 gap-1 px-4 py-2 rounded-xl w-fit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            Back
          </button>
        </Link>
      <div className="py-12 px-6 flex-1">
      <h3 className="flex item-center mb-8 justify-center uppercase text-[#295700] text-4xl font-bold">
          Recent Mood
        </h3>
        <div className="min-h-[40vh] flex flex-col justify-center">
          {allMoods ? (
            allMoods?.map((each_post) => {
              return (
                <div className="flex items-start gap-20 mb-8 border-b-2 boder-gray-300">
                  <div className="h-[100%] flex items-center flex-col">
                    <p>{moodSmiley[convertKeyToCamelCase(each_post.mood)]}</p>
                  </div>
                  <div className="">
                    <h4 className="font-bold">
                      {months[Number(each_post.createdAt.substring(5, 7)) - 1]}{" "}
                      {each_post.createdAt.substring(8, 10)},{" "}
                      {each_post.createdAt.substring(0, 4)}
                    </h4>
                    <p className="py-3">{each_post.note}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="font-semibold text-lg text-[#295700]">
              Your Previous moods are looading...
            </p>
          )}
        </div>

        {/* <div className="flex items-center justify-center gap-10 mt-4">
          <button
            // onClick={handlePrev}
            className="py-1 px-4 bg-[#295700] text-white font-medium hover:bg-white hover:text-[#295700] border-2 border-[#295700]"
          >
            Prev
          </button>
          <button
            // onClick={handleNext}
            className="py-1 px-4 bg-[#295700] text-white font-medium hover:bg-white hover:text-[#295700] border-2 border-[#295700]"
          >
            Next
          </button>
        </div> */}
        {/* <p className="text-sm text-center text-gray-800 mt-4">
          Page {currentPage} out of 7
        </p> */}
      </div>
      </div>
      <Footer />
    </div>
  );
}
{/* <div><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
<path strokeLinecap="round" strokeLinejoin="round" d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
</svg>
</div> */}
export default MoodUi;
